import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
import AssetLevelList from 'asset_level/components/list';

class AssetLevelRowContainer extends Component {
  render = () => (
    <AssetLevelList.Row
      handleToggle={this.props.handleToggle}
      company={this.props.company}
      subcompany={this.props.subcompany}
      asset_level={this.props.asset_level}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
});

export default connect(mapStateToProps, null)(AssetLevelRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/containers/AssetLevelRowContainer.js